import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import NameHeader from 'components/Client/NameHeader/NameHeader'
import Subnavigation from '../Subnavigation/Subnavigation'
import SubnavigationItem from '../Subnavigation/SubnavigationItem'
import LoginSettings from '../LoginSettings/LoginSettings'
import PersonalSettings from '../PersonalSettings/PersonalSettings'
import {
  BaseComponent,
} from 'belle-js'

class ProfileSettingsPage extends BaseComponent {

  constructor (props) {
    super(props)
    this.state = {}

    this.bind('handleProfileActiveTab')
  }

  handleProfileActiveTab (label) {
    const { goProfileSubSection } = this.props

    goProfileSubSection(label)
  }

  render () {
    const {
      location: {
        payload: { profileType }
      },
      user,
      clientExperience
    } = this.props

    return (
      <Fragment>
        <NameHeader name={user.fullName} />
        <Subnavigation
          activeTab={profileType}
          onItemSelected={this.handleProfileActiveTab}>
          <SubnavigationItem label="login">
            <LoginSettings user={user} />
          </SubnavigationItem>
          { clientExperience &&
            <SubnavigationItem label="personal">
              <PersonalSettings user={user} />
            </SubnavigationItem>
          }
        </Subnavigation>
      </Fragment>
    )
  }

}

ProfileSettingsPage.defaultProps = {
  user: {},
  goDocumentsSubSection: () => {},
  clientExperience: false,
}

ProfileSettingsPage.propTypes = {
  user: PropTypes.object,
  location: PropTypes.object.isRequired,
  goDocumentsSubSection: PropTypes.func,
  clientExperience: PropTypes.bool,
}

export default ProfileSettingsPage



// WEBPACK FOOTER //
// ./src/components/Client/ProfileSettingsPage/ProfileSettingsPage.jsx